var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('filters-list',{attrs:{"filters":_vm.filters},on:{"filterChanged":_vm.startFiltering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }